import apiRequestService from '../component/ApiRequestService';
import { AppSetting } from '../common/function';
export default class HelpText{
    AppSetting = AppSetting();
    constructor(){
        this.helpTextMap = undefined;
    }

    fetch(){
         this.helpTextMap = JSON.parse(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_helpTextMap`));
    }

    save(){
        window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_helpTextMap`,JSON.stringify(this.helpTextMap) );
    }


   getHelpTextForKey(key){
      
        if(!this.helpTextMap )
        {
            this.fetch();
        }
        if(this.helpTextMap && this.helpTextMap[key]){
            return this.helpTextMap[key].help_text;
        }
        
        return '';
   }

    deleteHelpTextItem(helpTextItem){
        return new Promise((resolve, reject) => {            
            apiRequestService({
                method: 'post',
                url: '/deleteHelpText',
                data:helpTextItem
            }).then(res => {
                if (res.data.message !== null && res.data.message !== '') {
                    reject(res.data.message);
                }
            else{
                delete this.helpTextMap[helpTextItem.key]; 
                console.log('this.helpTextMap',this.helpTextMap);
                
                this.save();
                resolve(this.helpTextMap);                     
            }
            }).catch(err =>{
                reject(err);
            });
        });
    }

    saveHelpTextItem(helpTextItem){
        return new Promise((resolve, reject) => {            
            apiRequestService({
                method: 'post',
                url: '/addHelpText',
                data:helpTextItem
            }).then(res => {
                if (res.data.message !== null && res.data.message !== '') {
                    reject(res.data.message);
                }
            else{
                this.helpTextMap[helpTextItem.key] = helpTextItem; 
                this.save();
                resolve(this.helpTextMap);                     
            }
            }).catch(err =>{
                reject(err);
            });
        });
    }

    getAllHelpText(force){
        return new Promise((resolve, reject) => {
            if( !force && this.helpTextMap && this.helpTextMap.length > 0){
                resolve(this.helpTextMap);
            }else{
                apiRequestService({
                    method: 'post',
                    url: '/getAllHelpText'
                }).then(res => {
                    if (res.data.message !== null && res.data.message !== '') {
                        reject(res.data.message);
                    }
                else{
                    let helpTextMap =res.data.data; 
                    this.helpTextMap = helpTextMap;
                    this.save();
                    resolve(helpTextMap);                     
                }
                }).catch(err =>{
                    reject(err);
                });
            }
        });
    }

}